import React from "react";

function VisitGridLoading(props) {
  const { children } = props;

  return <>{children}</>;
}

export default VisitGridLoading;
